import React from "react";
import StaffingPreferenceSection from "./StaffingPreferenesSection";
import Scaffold from "../Scaffold/Scaffold";
import ScaffoldTitle from "../Scaffold/components/ScaffoldTitle";
import Flex from "../Generic/Flex";
import {
  CaregiverStaffingPreferenceTypes,
  CaregiverStaffingPreferencesSection,
  SectionTitle,
} from "../../messages";
import {
  BaselineLanguageIcon,
  BedEmptyIcon,
  DirectionsCarIcon,
  MdOptionsIcon,
  PersonIcon,
  PetsIcon,
  SmokingIcon,
} from "../../utils/icones";
import { translate } from "../../translate";
import { STRINGS } from "../../strings";
import { assertNever } from "assert-never";

const getIconByTitle = (title: SectionTitle) => {
  switch (title) {
    case "Patient":
      return <BedEmptyIcon />;
    case "Household":
      return <PetsIcon />;
    case "Smoking":
      return <SmokingIcon />;
    case "Culture":
      return <img src="assets/staffing_preferences_kosher.svg" />;
    case "Transport":
      return <DirectionsCarIcon />;
    case "Language":
      return <BaselineLanguageIcon />;
    case "About Me":
      return <PersonIcon />;
    case "Cases":
      return <MdOptionsIcon />;
    default:
      assertNever(title, true);
  }
};

interface MyStaffingPreferencesScreenProps {
  sections: CaregiverStaffingPreferencesSection[];
  onChangeAnswer: (
    type: CaregiverStaffingPreferenceTypes,
    value: boolean | string | string[] | number | null
  ) => void;
  onClickGoBack: () => void;
}

const MyStaffingPreferencesScreen = (props: MyStaffingPreferencesScreenProps) => {
  return (
    <Scaffold
      title={<ScaffoldTitle label={translate(STRINGS.MY_STAFFING_PREFERENCES)} />}
      className="CaseSettingsScreen"
      onClickGoBack={props.onClickGoBack}
    >
      <Flex direction="column" gap={20}>
        {props.sections.map((section, index) => {
          return (
            <StaffingPreferenceSection
              key={`staffing-preference-section-${index}`}
              title={section.title}
              iconSrc={getIconByTitle(section.title)}
              preferences={section.preferences}
              onChangeAnswer={props.onChangeAnswer}
            />
          );
        })}
      </Flex>
    </Scaffold>
  );
};

export default MyStaffingPreferencesScreen;
